import { combineReducers } from 'redux';
import userData from './User';
import userTypes from './Global';

export default combineReducers({
  userData,
  userTypes,
});
